// Loudest moment of a microphone stream while recording. A muted or wrong microphone stays near zero
// all along; a quiet voice still peaks above it. The transcription model invents text for silence,
// so a silent take is stopped here instead of being sent.
const SILENT_LEVEL = 0.01; // RMS of a 2048-sample window (0..1)
const MIN_SECONDS = 3;

export function startLevelMeter(stream) {
  let peak = null; // null: could not measure, so never block the recording
  let timer = null;
  let ctx = null;
  try {
    const AudioCtx = window.AudioContext || window.webkitAudioContext;
    ctx = new AudioCtx();
    // Safari may start the context suspended outside a user gesture; it would read silence.
    if (ctx.state === "suspended") ctx.resume().catch(() => {});
    const analyser = ctx.createAnalyser();
    analyser.fftSize = 2048;
    ctx.createMediaStreamSource(stream).connect(analyser);
    const buf = new Float32Array(analyser.fftSize);
    peak = 0;
    timer = setInterval(() => {
      analyser.getFloatTimeDomainData(buf);
      let sum = 0;
      for (let i = 0; i < buf.length; i++) sum += buf[i] * buf[i];
      peak = Math.max(peak, Math.sqrt(sum / buf.length));
    }, 150);
  } catch (e) {
    peak = null;
  }
  return {
    isSilent(seconds) {
      // Only trust the reading when the context really ran.
      if (!ctx || ctx.state !== "running") return false;
      return peak !== null && seconds >= MIN_SECONDS && peak < SILENT_LEVEL;
    },
    stop() {
      clearInterval(timer);
      if (ctx && ctx.state !== "closed") ctx.close().catch(() => {});
    },
  };
}

export const SILENT_MESSAGE =
  "Não ouvimos nenhum som nesta gravação. Confira se o microfone certo está ligado e sem mudo, e grave de novo.";
